<template lang="pug">
.contacts-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1 {{ $t('contactsCardTable.name') }}: {{ item.name }}
      .mb-1 {{ $t('contactsCardTable.email') }}: {{ item.email }}
      .mb-1(v-if='item.phone') {{ $t('contactsCardTable.phone') }}: {{ item.phone | phone }}
      .mb-0
        button.btn-edit-contact(
          :title='$t("contactsCardTable.use")'
          @click.stop='openEditContactModal(item)'
        )
          icon(name='pen-to-square')
        button.btn-delete-contact(
          :title='$t("contactsCardTable.delete")'
          @click.stop='openDeleteContactModal(item)'
        )
          icon.icon--canceled(name='trash-can')
    template(v-slot:table-head)
      th(style='width: 20%') {{ $t('contactsCardTable.name') }}
      th(style='width: 40%') {{ $t('contactsCardTable.email') }}
      th(style='width: 34%') {{ $t('contactsCardTable.phone') }}
      th(style='width: 6%')
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ item.name }}
      td {{ item.email }}
      td {{ item.phone | phone }}
      td
        .text-end.d-flex
          button(
            :title='$t("contactsCardTable.use")'
            @click.stop='openEditContactModal(item)'
          )
            icon(name='pen-to-square')
          button(
            :title='$t("contactsCardTable.delete")'
            @click.stop='openDeleteContactModal(item)'
          )
            icon.icon--canceled(name='trash-can')
  edit-contact-modal(
    :contact='this.selectedContact'
    :title='this.selectedContact.name'
    @refresh='$emit("item-edited")'
    ref='editContactModal'
  )
  delete-contact-modal(
    :contact='this.selectedContact'
    @refresh='$emit("item-deleted")'
    ref='deleteContactModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import EditContactModal from '@/modules/account/components/organisms/modals/EditContactModal.vue';
import DeleteContactModal from '@/modules/account/components/organisms/modals/DeleteContactModal.vue';
import parsePhoneNumber from 'libphonenumber-js';

export default {
  name: 'UsersGuestCardTable',
  components: {
    Icon,
    CardTable,
    EditContactModal,
    DeleteContactModal,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedContact: {},
    };
  },
  filters: {
    phone: function (phoneNumber) {
      if (phoneNumber === null) return '-';

      return parsePhoneNumber(phoneNumber).formatNational();
    },
  },
  methods: {
    openEditContactModal(contact) {
      this.selectedContact = contact;
      this.$nextTick(this.$refs.editContactModal.$refs.modal.open);
    },
    openDeleteContactModal(contact) {
      this.selectedContact = contact;
      this.$nextTick(this.$refs.deleteContactModal.$refs.modal.open);
    },
  },
};
</script>

<style lang="stylus">
.contacts-card-table
  .btn-edit-contact
    position: absolute
    top: 0.5rem
    right: 0.45rem
  .btn-delete-contact
    position: absolute
    bottom: 0.8rem
    right: 0.5rem
</style>
